const successTagMap = {
  "success.default.message": "Success",
  "nova.NOT_FOUND": "NovaSuccess:Unable to retrieve",
  "nova.NOT_AUTHENTICATED": "NovaSuccess:Unable to authenticate",
  "nova.PENDING": "NovaSuccess:Pending"
}

export const mapSuccessKeyToTag = (errorKey) => {
  return successTagMap[errorKey] ||
    successTagMap['success.default.message'];
}



// WEBPACK FOOTER //
// ./application/src/utilities/successTagging.js